import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import AuthContext from '../AuthContext';
import { API_URL } from '../services/api';
import styles from './Login.module.css';
import 'flag-icons/css/flag-icons.min.css';

const Login = () => {
  const { login } = useContext(AuthContext);
  const { language, setLanguage, t } = useContext(LanguageContext); // Use language context
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_URL}/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      if (response.ok) {
        const data = await response.json();
        login(data.access, data.refresh);
        navigate('/dashboard');
      } else {
        alert(t('invalidCredentials'));
      }
    } catch (error) {
      alert(t('invalidCredentials'));
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.languageFlags}>
        <span
          className={`fi fi-pl ${language === 'pl' ? styles.activeFlag : ''}`}
          onClick={() => setLanguage('pl')}
          title="Polski"
        ></span>
        <span
          className={`fi fi-gb ${language === 'en' ? styles.activeFlag : ''}`}
          onClick={() => setLanguage('en')}
          title="English"
        ></span>
        <span
          className={`fi fi-de ${language === 'de' ? styles.activeFlag : ''}`}
          onClick={() => setLanguage('de')}
          title="Deutsch"
        ></span>
      </div>
      <div className={styles.card}>
        <h1 className={styles.title}>{t('login')}</h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username" className={styles.label}>
              {t('username')}
            </label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder={t('enterUsername')}
              onChange={handleChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              {t('password')}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder={t('enterPassword')}
              onChange={handleChange}
              className={styles.input}
              required
            />
          </div>
          <button type="submit" className={styles.button}>
            {t('login')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
